export const Youtube = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8369 3.34013C17.5903 3.57335 18.1824 4.25803 18.3841 5.12929C18.7485 6.70687 18.75 10.0003 18.75 10.0003C18.75 10.0003 18.75 13.2938 18.3841 14.8714C18.1824 15.7426 17.5903 16.4273 16.8369 16.6605C15.4727 17.0837 9.99997 17.0837 9.99997 17.0837C9.99997 17.0837 4.52728 17.0837 3.16307 16.6605C2.40966 16.4273 1.81758 15.7426 1.6159 14.8714C1.25 13.2938 1.25 10.0003 1.25 10.0003C1.25 10.0003 1.25 6.70687 1.6159 5.12929C1.81758 4.25803 2.40966 3.57335 3.16307 3.34013C4.52728 2.91699 9.99997 2.91699 9.99997 2.91699C9.99997 2.91699 15.4727 2.91699 16.8369 3.34013ZM12.9278 10.0006L8.16488 12.7503V7.25087L12.9278 10.0006Z"
      fill="#FE4B18"
    />
  </svg>
)

export default Youtube
